import { Component, OnInit, HostListener } from '@angular/core';
import { AdminAuthenticationService } from '../services/admin-authentication.service';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './admin-layout.component.html'
})
export class AdminLayoutComponent implements OnInit {

    public disabled: boolean = false;
    public status: {isopen: boolean} = {isopen: false};
    public loggedUser = localStorage.getItem("username");
    public loggedUserType = localStorage.getItem("userRole");
    public loggedUsername = this.loggedUserType = 'admin' ? 'Admin' : this.loggedUser;
    clients;
    clientid;
    companyname;
    clientname= "select";
    userType = "";    
    headerText = null; 

    //bannerContent = "M3S offers an extensive range of flexible talent solutions helping you to attract and recruit the best talent for your company.";

    constructor(private authService : AdminAuthenticationService,
                private router: Router,
                private userService: UserService) { 
      this.userService.getHeaderText.subscribe(headerText => {
        this.headerText =  headerText;
        this.userType = (this.headerText) ? this.headerText : "Clients"; 
        if(this.headerText == 'Add Talent Pool' || this.headerText == 'Edit Talent Pool') {
          this.userType = 'Talent Pools';
        }
        if(this.headerText == 'Add Client' || this.headerText == 'Edit Client') {
          this.userType = 'Clients';
        }
      });
    }    

    @HostListener('document:click', ['$event', '$event.target'])
        public onClick(event: MouseEvent): void {      
        document.querySelector('.dropdown').classList.remove('open'); 
        document.querySelector('.select-usertype').classList.remove('open');   
    }
    
    public toggleDropdown($event: MouseEvent): void {    
      $event.preventDefault();
      $event.stopPropagation();
      this.status.isopen = !this.status.isopen;
      document.querySelector('.dropdown').classList.toggle('open');     
    } 

    public selectUserType($event: MouseEvent): void {    
      $event.preventDefault();
      $event.stopPropagation();
      document.querySelector('.select-usertype').classList.toggle('open');     
    } 

    setClietSesion(obj){       
      localStorage.setItem("selectedClient",obj.value);       
    }

    navigateUserType(userType) {      
      if(userType == "clients") {
        this.router.navigate(['/admin/dashboard']);
        this.userType = "Clients";
        // this.headerText = "Clients";
        //this.bannerContent = "M3S offers an extensive range of flexible talent solutions helping you to attract and recruit the best talent for your company.";
      } else if(userType == "recruiters") {
        this.router.navigate(['/admin/manage-recruiter']);
        this.userType = "Recruiters";
      } else if(userType == "talentpools") {
        this.router.navigate(['/admin/talentpool']);
        this.userType = "Talent Pools";
      } 
    }

    public logOut() {   
      this.authService.logout();
    }


    ngOnInit(): void {  
    }

  
}



// WEBPACK FOOTER //
// ./src/app/layouts/admin-layout.component.ts